(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fullscreen-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fullscreen-slider')) {
  customElements.define('fullscreen-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.visible = true;
      this.hovered = false;
      this.focused = false;
      this.editing = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.paused = this.reduced.matches;
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Math.max(3000, Number(this.dataset.interval) || 7000);
      this.listen(this, 'click', event => {
        const button = event.target.closest('button');
        if (!button || button.closest('fullscreen-slider') !== this) return;
        if (button.hasAttribute('data-go')) this.show(Number(button.dataset.go), true);
        if (button.hasAttribute('data-toggle-motion')) {
          this.paused = !this.paused;
          this.sync();
        }
      });
      this.listen(this, 'keydown', event => {
        if (event.target.closest('[data-content-block], .fullscreen-cta') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.show(index, true);
      });
      this.listen(this, 'pointerenter', event => {
        if (event.pointerType === 'mouse' && this.dataset.pauseHover === 'true') { this.hovered = true; this.schedule(); }
      });
      this.listen(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      this.listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
      this.listen(this, 'focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      this.listen(this, 'pointerdown', event => {
        this.touchStart = event.pointerType === 'touch' && !event.target.closest('a, button, input, textarea, select') ? { x: event.clientX, y: event.clientY } : null;
      });
      this.listen(this, 'pointerup', event => {
        if (!this.touchStart) return;
        const dx = event.clientX - this.touchStart.x;
        const dy = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true);
      });
      this.listen(this, 'pointercancel', () => { this.touchStart = null; });
      this.listen(document, 'visibilitychange', () => this.sync());
      this.listen(this.mobile, 'change', () => this.sync());
      this.listen(this.reduced, 'change', () => { this.paused = this.reduced.matches; this.sync(); });
      this.listen(window, 'resize', () => this.updateWidth());
      this.listen(window, 'scroll', () => this.syncHeaderScroll(), { passive: true });
      ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:unload'].forEach(type => {
        this.listen(document, type, () => this.bindTransparentHeader());
      });
      this.listen(document, 'shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const slide = event.target.closest('[data-slide]');
        if (slide) { this.editing = true; this.show(this.slides.indexOf(slide), true); }
      });
      this.listen(document, 'shopify:block:deselect', event => {
        if (this.contains(event.target)) { this.editing = false; this.schedule(); }
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: 0.01 });
        this.observer.observe(this);
      }
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateWidth());
        this.resizeObserver.observe(document.documentElement);
      }
      this.updateWidth();
      this.bindTransparentHeader();
      this.track = this.querySelector('.fullscreen-track');
      this.decodedImages = new WeakSet();
      this.track.setAttribute('data-ready', '');
      this.slides.forEach(slide => { slide.hidden = false; });
      this.show(0);
    }
    listen(target, type, handler, options = {}) { target.addEventListener(type, handler, { ...options, signal: this.controller.signal }); }
    bindTransparentHeader() {
      const section = this.closest('.shopify-section');
      const shell = this.closest('.fullscreen-shell');
      const eligible = section && section.closest('main, [role="main"]') && section.matches('.shopify-section:first-child') && shell?.hasAttribute('allow-transparent-header');
      const header = eligible ? document.querySelector('.header-section') : null;
      if (!header) {
        this.releaseTransparentHeader();
        return;
      }
      if (this.headerSection === header && this.headerOwner === section.id) {
        this.syncHeaderScroll();
        return;
      }
      this.releaseTransparentHeader();
      this.headerSection = header;
      this.headerOwner = section.id;
      header.setAttribute('data-fullscreen-owner', this.headerOwner);
      // Use the theme's own initialization for overlay placement and logo handling.
      header.querySelector('.header')?.init?.();
      this.syncHeaderScroll();
    }
    syncHeaderScroll() {
      if (!this.headerSection || this.headerSection.getAttribute('data-fullscreen-owner') !== this.headerOwner) return;
      const scrolled = window.scrollY > 0;
      if (this.headerSection.hasAttribute('data-fullscreen-scrolled') !== scrolled) {
        this.headerSection.toggleAttribute('data-fullscreen-scrolled', scrolled);
      }
    }
    releaseTransparentHeader() {
      const header = this.headerSection;
      if (header && header.getAttribute('data-fullscreen-owner') === this.headerOwner) {
        header.removeAttribute('data-fullscreen-scrolled');
        header.removeAttribute('data-fullscreen-owner');
        // Re-evaluate native transparency after the editor removes or moves this section.
        requestAnimationFrame(() => { if (header.isConnected) header.querySelector('.header')?.init?.(); });
      }
      this.headerSection = null;
      this.headerOwner = null;
    }
    updateWidth() {
      this.closest('.shopify-section')?.style.setProperty('--fullscreen-viewport-width', document.documentElement.clientWidth + 'px');
    }
    show(index, announce = false) {
      if (!this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      // Queue navigation instead of interrupting a visible dissolve or an image load.
      if (this.fadeAnimation || this.preparing) {
        this.pendingSlide = { index: next, announce };
        return;
      }
      const images = Array.from(this.slides[next].querySelectorAll('img'));
      if (next !== this.index && images.some(image => !this.decodedImages.has(image))) {
        const controller = this.controller;
        this.preparing = true;
        clearTimeout(this.timer);
        Promise.all(images.map(image => {
          image.loading = 'eager';
          return this.decodeImage(image).then(ready => {
            if (ready) this.decodedImages.add(image);
            return ready;
          });
        })).then(results => {
          if (controller.signal.aborted) return;
          this.preparing = false;
          const pending = this.pendingSlide;
          this.pendingSlide = null;
          if (pending) this.show(pending.index, pending.announce);
          else if (results.every(Boolean)) this.show(next, announce);
          else this.schedule(); // Leave the current picture visible if the next image fails.
        });
        return;
      }
      const previous = this.index;
      this.index = next;
      this.slides.forEach((slide, i) => {
        // Keep both layers rendered throughout the dissolve, including the last-to-first loop.
        slide.hidden = false;
        slide.inert = i !== next;
        slide.setAttribute('aria-hidden', String(i !== next));
      });
      this.querySelectorAll('[data-go]').forEach(button => {
        if (Number(button.dataset.go) === next) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      // Load the current and upcoming image before it enters the viewport.
      [this.slides[next], this.slides[(next + 1) % this.slides.length]].forEach(slide => {
        slide.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
        slide.querySelectorAll('video').forEach(video => { video.preload = 'metadata'; });
      });
      if (previous !== next && !this.reduced.matches && this.slides[next].animate) {
        const outgoing = this.slides[previous];
        const incoming = this.slides[next];
        this.slides.forEach(slide => { slide.style.opacity = '0'; slide.style.zIndex = '0'; });
        // An opaque backing slide prevents the page background bleeding through the dissolve.
        outgoing.style.opacity = '1';
        outgoing.style.zIndex = '1';
        incoming.style.opacity = '1';
        incoming.style.zIndex = '2';
        const animation = incoming.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: 2000, easing: 'cubic-bezier(0.45, 0, 0.55, 1)', fill: 'both'
        });
        this.fadeAnimation = animation;
        animation.onfinish = () => {
          if (this.fadeAnimation !== animation) return;
          this.clearFade();
          const pending = this.pendingSlide;
          this.pendingSlide = null;
          if (pending) this.show(pending.index, pending.announce);
          else this.schedule();
        };
      } else {
        this.clearFade();
      }
      if (announce) this.querySelector('.fullscreen-status').textContent = 'Slide ' + (next + 1) + ' of ' + this.slides.length;
      this.sync();
    }
    decodeImage(image) {
      if (image.decode) return image.decode().then(() => image.naturalWidth > 0, () => false);
      if (image.complete) return Promise.resolve(image.naturalWidth > 0);
      return new Promise(resolve => {
        image.addEventListener('load', () => resolve(image.naturalWidth > 0), { once: true });
        image.addEventListener('error', () => resolve(false), { once: true });
      });
    }
    clearFade() {
      const animation = this.fadeAnimation;
      this.fadeAnimation = null;
      this.slides.forEach((slide, i) => {
        slide.style.opacity = i === this.index ? '1' : '0';
        slide.style.zIndex = i === this.index ? '2' : '0';
      });
      animation?.cancel();
    }
    sync() {
      const canPlay = !this.paused && this.visible && !document.hidden;
      this.slides.forEach((slide, index) => slide.querySelectorAll('video').forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        if (canPlay && index === this.index && getComputedStyle(video).display !== 'none') {
          const play = video.play();
          if (play && play.catch) play.catch(() => {});
        } else video.pause();
      }));
      const toggle = this.querySelector('[data-toggle-motion]');
      if (toggle) {
        const hasMotion = this.slides.some(slide => slide.querySelector('video')) || (this.autoplay && this.slides.length > 1);
        toggle.hidden = !hasMotion;
        toggle.style.display = hasMotion ? '' : 'none';
        toggle.textContent = this.paused ? 'Play' : 'Pause';
        toggle.setAttribute('aria-pressed', String(this.paused));
        toggle.setAttribute('aria-label', this.paused ? 'Play slideshow and video' : 'Pause slideshow and video');
      }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.fadeAnimation || this.preparing || !this.autoplay || this.slides.length < 2 || this.paused || !this.visible || document.hidden || this.hovered || this.focused || this.editing || window.Shopify?.designMode) return;
      this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
    }
    disconnectedCallback() {
      this.releaseTransparentHeader();
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.clearFade();
      this.pendingSlide = null;
      this.slides.forEach(slide => { slide.style.opacity = ''; slide.style.zIndex = ''; });
      this.preparing = false;
      this.track?.removeAttribute('data-ready');
      this.slides.forEach((slide, i) => { slide.hidden = i !== 0; });
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
